"use client";
import { useEffect, useState, useCallback } from "react";

import Portal from "@stadium/ui/src/components/portal";

import { disableBodyScroll, enableBodyScroll } from "@stadium/helpers/dom";

import styles from "./main.module.scss";

const emptyObj = {};

export const useModal = (type, Component) => {
  const [isOpen, setOpen] = useState(false);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (isOpen) {
      disableBodyScroll(styles.stopScroll);
    }
    return () => isOpen && enableBodyScroll(styles.stopScroll);
  }, [isOpen]);

  const renderModal = (data, appendWrapper = true) => {
    const { rootClass = "", dialogClass = "" } = data?.classes || emptyObj;
    const { closeOnBackdropClick = true } = data || emptyObj;

    const renderContent = () => (
      <>
        <div
          className={`modal fade show d-block ${rootClass}`}
          aria-hidden="false"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className={`modal-dialog modal-dialog-centered border-radius-md-0 border-radius-lg-8 ${dialogClass}`}
          >
            <Component {...data} closeModal={closeModal} />
          </div>
        </div>
        <div className="modal-backdrop show" onClick={closeOnBackdropClick ? closeModal : null} />
      </>
    );

    return (
      isOpen && (
        <Portal id="modal-root" dataContainerId={type}>
          {appendWrapper ? renderContent() : <Component {...data} closeModal={closeModal} />}
        </Portal>
      )
    );
  };

  return { openModal, renderModal, isOpen, closeModal };
};
